// Copyright 2026. WebPros International GmbH. All rights reserved.

import Select, {
    GroupBase,
    Props,
    StylesConfig,
    CSSObjectWithLabel,
} from 'react-select';
import { selectInputStyles } from 'common/components/Select/styles';

export interface ISelectInputProps<
    T,
    IsMulti extends boolean = false,
    Group extends GroupBase<T> = GroupBase<T>
> extends Props<T, IsMulti, Group> { // No Omit here
    minHeight?: string | number;
    width?: string | number;
    hasErrors?: boolean;
    options?: ReadonlyArray<T | (Group extends GroupBase<T> ? Group : any)>; // eslint-disable-line @typescript-eslint/no-explicit-any
}

const SelectInput = <
    T,
    IsMulti extends boolean = false,
    Group extends GroupBase<T> = GroupBase<T>
>(props: ISelectInputProps<T, IsMulti, Group>) => {
    const styles = selectInputStyles as StylesConfig;

    const actualProps = {
        ...props,
        components: {
            ...props.components,
            IndicatorSeparator: () => null,
        },
        styles: {
            ...styles,
            control: (base: CSSObjectWithLabel) => ({
                ...base,
                minHeight: props.minHeight,
                width: props.width,
            }),
        },
    };

    const SelectAny = Select as any; // eslint-disable-line @typescript-eslint/no-explicit-any

    return <SelectAny {...actualProps} />;
};

export default SelectInput;
